import classNames from 'classnames'

import {omitPropsExcept, pickProps} from './matchProps'

/** Inteligently merges props, without overwriting className & style
 * */
export default function mergeProps(target, ...sources) {
  const result = target
  for (const source of sources) {
    if (!source) continue
    for (const key in source) {
      if (!source.hasOwnProperty(key)) continue
      switch (key) {
        case 'className':
          result[key] = classNames(result[key], source[key])
          continue
        case 'style':
          result[key] = result[key]
            ? {...result[key], ...source[key]}
            : source[key]
          continue
        default:
      }
      result[key] = source[key]
    }
  }
  return result
}

/** Inteligently merges props with defaults, omitting specific props */
export function omitAndMergeProps(
  props: any,
  omit,
  defaultsToMerge?: any | null
) {
  return mergeProps(
    {},
    defaultsToMerge,
    omitPropsExcept(props, omit, defaultsToMerge)
  )
}

export function pickAndMergeProps(
  props: any,
  pick,
  defaultsToMerge?: any | null
) {
  return mergeProps(
    {},
    defaultsToMerge,
    pickProps(props, [pick, defaultsToMerge])
  )
}
